import React from 'react';
import { motion } from 'framer-motion';
import { Building2, MessageSquare, HomeIcon } from 'lucide-react';

const AdoptionSteps: React.FC = () => {
  const steps = [
    {
      id: 1,
      icon: <Building2 size={28} className="text-accent" />,
      title: 'Vizită la adăpost',
      description: 'Vino la adăpost pentru a cunoaște potențialul prieten blănos',
    },
    {
      id: 2,
      icon: <MessageSquare size={28} className="text-accent" />,
      title: 'Completează un formular',
      description: 'Completează formularul de adopție și discută cu un reprezentant despre așteptările tale',
    },
    {
      id: 3,
      icon: <HomeIcon size={28} className="text-accent" />,
      title: 'Pregătește-te pentru adopție',
      description: 'Pregătește-ți casa pentru noul membru al familiei',
    },
  ];

  return (
    <div className="relative">
      {/* Connecting lines */}
      {/* <div className="hidden md:block absolute top-1/4 left-0 right-0 h-0.5 bg-primary-300 z-0"></div> */}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
        {steps.map((step, index) => (
          <motion.div
            key={step.id}
            className="flex flex-col items-center text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <div className="bg-white w-16 h-16 rounded-full shadow-md flex items-center justify-center mb-4">
              <div className="text-2xl font-bold text-accent">{step.id}</div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md w-full">
              <div className="bg-accent-100 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          </motion.div>
        ))}
      </div>

    </div>
  );
};

export default AdoptionSteps;